import { Component, Input } from '@angular/core';
import { LayoutService } from '@app/layout/layout.service';
import { ADOCRecord } from '../adoc-report';

interface DiffEntry {
  LogInstance: number;
  CategoryId: string;
  LineNum: number;
  PropertyName?: string;
  OldValue?: string;
  NewValue?: string;
  Visorder?: number;
  UpdateDateTime: string;
  USER_CODE: string;
  U_NAME: string;
  Change: 0 | 1 | 2;
}

@Component({
  selector: 'app-compare-result',
  templateUrl: './compare-result.component.html',
  styleUrls: ['./compare-result.component.less'],
})
export class CompareResultComponent {
  @Input() selectedRows: any[];
  @Input() moduleId: number;
  @Input() lastInstanceIndex: number;
  @Input() adocRows: ADOCRecord[];

  diffEntries: DiffEntry[] = [];
  today: string = new Date().toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });

  isLoading = false;

  constructor(private layoutService: LayoutService) {}

  ngOnInit(): void {
    console.log(this.selectedRows);

    const row1 = this.selectedRows[0];
    const row2 = this.selectedRows[1];

    const id = this.moduleId;
    const selectedId = row1.DocEntry;
    const logInstance1 = row1.LogInstanc;
    let logInstance2 = -1;
    if (row2 !== undefined) {
      logInstance2 = row2.LogInstanc;
    }

    const instance1 = logInstance1 < logInstance2 ? logInstance1 : logInstance2;
    const instance2 = logInstance2 > logInstance1 ? logInstance2 : logInstance1;
    this.isLoading = true;
    this.layoutService
      .getDifferenceBetweenTwoInstances(
        id,
        selectedId,
        instance1,
        instance2 === this.lastInstanceIndex ? 10000 : instance2
      )
      .subscribe(
        (result: DiffEntry[]) => {
          this.diffEntries = result;
          this.diffEntries.forEach((element) => {
            let row = this.adocRows.find(
              (x) => x.LogInstanc === element.LogInstance
            );
            if (row !== undefined) {
              element.UpdateDateTime = row.UpdateDateTime;
              element.USER_CODE = row.USER_CODE;
              element.U_NAME = row.U_NAME;
            }
          });
          this.isLoading = false;
        },
        (error) => {
          console.error('Failed to get differences', error);
          this.isLoading = false;
        }
      );
  }

  isRowAction(diff: DiffEntry): boolean {
    return diff.Change === 0 || diff.Change === 1;
  }

  getRowActionText(diff: DiffEntry): string {
    if (diff.Change === 0)
      return `Marketing Document (Rows) - History - Row ${
        diff.Visorder ?? diff.LineNum
      } added`;
    else if (diff.Change === 1)
      return `Marketing Document (Rows) - History - Row ${
        diff.Visorder ?? diff.LineNum
      } deleted`;
    return '';
  }

  isDocumentLines(diff: any): boolean {
    return diff.CategoryId?.toLowerCase() === 'document_lines';
  }
}
